import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type CategoryProductsCountFragment = { id: string, name: string, specCount: number };

export const CategoryProductsCountFragmentDoc = gql`
    fragment CategoryProductsCountFragment on CategoryProductsCountType {
  id
  name
  specCount
}
    `;